import { mergeAttributes, Node, wrappingInputRule } from "@tiptap/core";

const ListItemName = "listItem";
const TextStyleName = "textStyle";

export interface GiftListOptions {
  itemTypeName: string;
  HTMLAttributes: Record<string, any>;
  keepMarks: boolean;
  keepAttributes: boolean;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    giftList: {
      toggleGiftList: () => ReturnType;
    };
  }
}

export const inputRegex = /^\s*([-+*])\s$/;

export const GiftList = Node.create<GiftListOptions>({
  name: "giftList",

  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {
        class: "list-image-gift list-inside",
      },
      keepMarks: false,
      keepAttributes: false,
    };
  },

  group: "block list",

  content() {
    return `${this.options.itemTypeName}+`;
  },

  parseHTML() {
    return [
      {
        tag: "ul.list-image-gift",
      },
      {
        tag: "ul",
        getAttrs: (node) => {
          if (!(node instanceof HTMLElement)) return false;
          const hasGift = node.classList.contains("list-image-gift");
          return hasGift ? {} : false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["ul", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands() {
    return {
      toggleGiftList:
        () =>
        ({ commands, chain }) => {
          if (this.options.keepAttributes) {
            return chain()
              .toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
              .updateAttributes(ListItemName, this.editor.getAttributes(TextStyleName))
              .run();
          }
          return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Shift-g": () => this.editor.commands.toggleGiftList(),
    };
  },

  addInputRules() {
    let inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type,
    });

    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: () => {
          return this.editor.getAttributes(TextStyleName);
        },
        editor: this.editor,
      });
    }
    return [inputRule];
  },
});
